"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.addToOrFilterFrom = exports.hasLength = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var curryCallback = function curryCallback(fn, value) {
  return function () {
    return fn(value);
  };
};

var filterByValue = function filterByValue() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;
  return arr.filter(function (i) {
    return i !== value;
  });
};

var hasLength = function hasLength(arr) {
  return Array.isArray(arr) && arr.length > 0;
};

exports.hasLength = hasLength;

var addToOrFilterFrom = function addToOrFilterFrom() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;
  return arr.includes(value) ? filterByValue(arr, value) : arr.concat(value);
};

exports.addToOrFilterFrom = addToOrFilterFrom;

var useCheckboxes = function useCheckboxes() {
  var _react$default$useSta = _react.default.useState([]),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      checked = _react$default$useSta2[0],
      setChecked = _react$default$useSta2[1];

  var isNotEmpty = hasLength(checked);
  var clear = curryCallback(setChecked, []);

  var isChecked = _react.default.useCallback(function (key) {
    return checked.includes(key);
  }, [checked]);

  var onCheck = function onCheck(key) {
    return function () {
      return setChecked(addToOrFilterFrom(checked, key));
    };
  };

  var onCheckAll = function onCheckAll(ids) {
    return !isNotEmpty ? curryCallback(setChecked, ids) : clear;
  };

  var hasChecked = function hasChecked() {
    return _react.default.useCallback(isNotEmpty, [checked]);
  };

  return {
    checked: checked,
    setChecked: setChecked,
    onCheck: onCheck,
    onCheckAll: onCheckAll,
    isChecked: isChecked,
    hasChecked: hasChecked,
    hasLength: hasLength,
    clear: clear
  };
};

var _default = useCheckboxes;
exports.default = _default;